<template>
  <v-container>
    <v-card max-width="344" class="mx-auto">
      <v-card-title class="justify-center" v-if="!fbuser">
        Bejelentkezés
      </v-card-title>
      <v-card-text class="text-center">
        <h3 v-if="fbuser">Bejelentkezve, mint: {{fbuser}}</h3>
        <div v-if="login_error">{{login_error}}</div>
        <v-form
          ref="login_form"
          v-model="login_valid"
        >
        <v-row v-if="!fbuser" class="justify-center pt-3">
          <v-col cols="12">
            <v-text-field
              v-model="username"
              label="E-mail cím"
              outlined
              :rules="emailRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="!fbuser" class="justify-center">
          <v-col cols="12">
            <v-text-field
              v-model="password"
              label="Jelszó"
              outlined
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="input-10-1"
              @click:append="show = !show"
              :rules="simpleRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="!fbuser" class="justify-center pb-3">
          <vue-recaptcha
            :sitekey="sitekey"
            ref="login_recaptcha"
            @verify="Login"
            @expired="loginRecaptchaReset"
            size="invisible"
          >
          </vue-recaptcha>
          <v-btn @click="loginRecaptchaExecute" rounded color="primary" :disabled="!login_valid || login_progress" :loading="login_progress">Küld</v-btn>
          </v-row>
        </v-form>
          <v-row class="justify-center pt-3">
            <v-btn rounded color="primary" @click="logout" v-if="fbuser">Kilépés</v-btn>
          </v-row>
        <p class="text-center" v-if="!fbuser">Amennyiben elfelejtette jelszavát: <br><a @click="pass_reset_dialog = true">itt tud újat igényelni</a></p>
      </v-card-text>
    </v-card>

    <br>

    <v-card max-width="344" class="mx-auto" v-if="fbuser">
      <v-card-title class="justify-center">
        Jelszó módosítás
      </v-card-title>
      <v-card-text class="text-center">
        <v-form
          ref="reset_form"
          v-model="reset_valid"
        >
        <v-row class="justify-center">
          <v-col cols="12">
            <v-text-field
              v-model="new_password"
              label="Új jelszó"
              outlined
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="input-10-1"
              @click:append="show = !show"
              :rules="passwordRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-col cols="12">
            <v-text-field
              v-model="new_repeat_password"
              label="Jelszó újra"
              outlined
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="input-10-1"
              @click:append="show = !show"
              :rules="repNewPasswordRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="justify-center pb-3">
            <v-btn @click="passwordChange()" rounded color="primary" :disabled="!reset_valid">Küld</v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <br>
    <p class="text-center" v-if="!fbuser">Hogyha még nincs felhasználói fiókja: <a @click="reg_dialog = true">itt tud regisztrálni!</a></p>
    <p class="text-center" v-if="!fbuser">(Már meglévő Diák Portál fiókját szintén a regisztrációval tudja aktiválni!)</p>
    <br>
    <v-row justify="center">
      <v-dialog v-model="reg_dialog" persistent scrollable max-width="650px">
        <v-card>
          <v-card-title>
            <span class="headline">Regisztráció</span>
          </v-card-title>
          <v-card-text class="text-center">
            <v-form
              ref="reg_form"
              v-model="reg_valid"
            >
            <v-row class="justify-center pt-3">
              <v-col cols="12">
                <v-text-field
                  v-model="reg_username"
                  label="E-mail cím"
                  outlined
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12">
                <v-text-field
                  v-model="reg_password"
                  label="Jelszó"
                  outlined
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  name="input-10-1"
                  @click:append="show = !show"
                  :rules="passwordRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12">
                <v-text-field
                  v-model="repeat_password"
                  label="Jelszó újra"
                  outlined
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  name="input-10-1"
                  @click:append="show = !show"
                  :rules="repPasswordRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
             <v-col cols="12">
              <v-checkbox
                v-model="adatkezeles"
              >
              <template v-slot:label>
                <div>
                  A regisztrációval elfogadom az
                      <a
                        target="_blank"
                        href="https://csigajogsi.hu/adatkezelesi_tajekoztato.pdf"
                        @click.stop
                      >
                        Adatkezelési tájékoztatóban
                      </a>
                    foglaltakat!
                  </div>
                </template>
              </v-checkbox>
              </v-col>
            </v-row>
          </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <vue-recaptcha
              :sitekey="sitekey"
              ref="reg_recaptcha"
              @verify="Registration"
              @expired="regRecaptchaReset"
              size="invisible"
            >
            </vue-recaptcha>
            <v-btn color="red" outlined @click="reg_dialog = false">Mégsem</v-btn>
            <v-btn @click="regRecaptchaExecute" outlined color="green" :disabled="!reg_valid || reg_button_loading || !adatkezeles" :loading="reg_button_loading">Regisztrál</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog
      v-model="reg_success_dialog"
      width="300"
    >
      <v-card>
        <v-card-text>
          <br>
          <h3 class="text-center">Sikeres regisztráció!</h3>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="reg_success_dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="reg_error_dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Hiba történt!
        </v-card-title>
        <v-card-text>
          <br>
          <h3 class="text-center">{{reg_error_text}}</h3>
          <br>
          <v-row justify="center">
          <v-btn
            v-if="login_user_check"
            color="primary"
            outlined
            @click="reg_error_dialog = false, reg_dialog = true"
          >
            Regisztráció
          </v-btn>
          <v-btn
            v-if="reg_error_code == 'auth/wrong-password'"
            color="primary"
            outlined
            @click="reg_error_dialog = false, pass_reset_dialog = true"
          >
            Jelszó emlékeztető
          </v-btn>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="reg_error_dialog = false, reg_button_loading = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="vartification_dialog"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          class="h5 grey lighten-2"
          primary-title
        >
          Regisztráció megerősítése!
        </v-card-title>
        <v-card-text>
          <br>
          <p>Kérjük írja be a megadott e-mail címre elküldött kódot:</p>
          <v-col cols="12" md="12">
            <v-text-field
              v-model="vertification"
              label="Jóváhagyó kód"
              outlined
            ></v-text-field>
          </v-col>
          <p>(Amennyiben az e-mailt néhány percen belül nem kapja meg, kattintson az <a @click="oldUserCheck(), vartification_error = 'E-mail sikeresen újraküldve', vartification_snackbar = true, response_success = 'true'">Újraküldés</a> hivatkozásra.)</p>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="vartification_dialog = false"
          >
            Mégsem
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="LoginVerfify"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="reg_vartification_dialog"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          E-mail cím megerősítése!
        </v-card-title>
        <v-card-text>
          <br>
          <p>Kérjük írja be a megadott e-mail címre elküldött kódot:</p>
          <v-col cols="12" md="12">
            <v-text-field
              v-model="reg_vertification_code"
              label="Jóváhagyó kód"
              outlined
            ></v-text-field>
          </v-col>
          <p>(Amennyiben az e-mailt néhány percen belül nem kapja meg, kattintson az <a @click="emailVertify(), vartification_error = 'E-mail sikeresen újraküldve', vartification_snackbar = true, response_success = 'true'">Újraküldés</a> hivatkozásra.)</p>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="reg_vartification_dialog = false"
          >
            Mégsem
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="registration_loading"
            :loading="registration_loading"
            @click="newRegistration"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="vartification_snackbar"
      :color="response_success == 'false' ? 'error' : ''"
    >
      {{ vartification_error }}
        <v-btn
          :color="response_success == 'false' ? '' : 'pink'"
          text
          @click="vartification_snackbar = false"
        >
          Bezár
        </v-btn>
    </v-snackbar>

    <v-dialog
      v-model="contract_choose_dialog"
      fullscreen
      hide-overlay
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Fiók kiválasztása</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="contract_choose_dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <br>
          <p>A megadott e-mail címmel már létezik felhasználói fiók a rendszerünkben (előfordulhat, hogy több is).
            Kérjük válassza ki, melyiket kívánja hozzárendelni az új regisztrációjához?</p>

            <v-data-table
              :headers="contracts_header"
              :items="contracts"
              class="elevation-1"
              :items-per-page="10"
              show-expand
            >
            <template v-slot:item.data-table-expand="{ item }">
              <v-btn
                color="primary"
                outlined
                @click="selected_customer_id = item.customer_id, selected_contract = item.contract_id, selected_name = item.full_name, selected_reg_date = item.registration_date, selected_contract_name = item.contract_name, selected_contract_date = item.contract_date, contract_confirm_dialog = true"
              >
                Kiválaszt
              </v-btn>
            </template>
            </v-data-table>

        </v-card-text>
      </v-card>

      <v-dialog
        v-model="contract_confirm_dialog"
        width="450"
      >
        <v-card>
          <v-card-title
            class="h5 grey lighten-2"
            primary-title
          >
            Biztosan ezt választja?
          </v-card-title>
          <v-card-text>
            <br>
            <b>Név:</b> {{selected_name}}
            <br>
            <b>Regisztráció ideje:</b> {{selected_reg_date}}
            <br>
            <b>Kategória:</b> {{selected_contract_name}}
            <br>
            <b>Szerződés ideje:</b> {{selected_contract_date}}
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="contract_confirm_dialog = false"
            >
              Mégsem
            </v-btn>
            <v-btn
              color="primary"
              text
              @click = "oldRegistration"
              :disabled="old_reg_button_load"
              :loading="old_reg_button_load"
            >
              Igen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-dialog>

    <v-dialog
      v-model="pass_reset_dialog"
      width="450"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          E-mail cím megadása
        </v-card-title>
        <v-card-text>
          <v-col cols="12" md="12">
            <v-text-field
              v-model="passwordResetEmail"
              label="E-mail cím"
              outlined
            ></v-text-field>
          </v-col>
          <p v-if="password_reset_error">{{password_reset_error}}</p>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="pass_reset_dialog = false"
          >
            Mégsem
          </v-btn>
          <vue-recaptcha
            :sitekey="sitekey"
            ref="pwreset_recaptcha"
            @verify="passwordReset"
            @expired="pwRecaptchaReset"
            size="invisible"
          >
          </vue-recaptcha>
          <v-btn
            color="primary"
            text
            @click="pwRecaptchaExecute"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>

</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth';
import VueRecaptcha from 'vue-recaptcha';

import {
  mapFields
} from 'vuex-map-fields'

export default {
  components: { VueRecaptcha },
  data () {
    return {
      username: '',
      password: '',
      reg_username: '',
      reg_password: '',
      repeat_password: '',
      login_error: '',
      fbuser: null,
      show: false,
      reg_dialog: false,
      reg_valid: true,
      login_valid: true,
      reset_valid: true,
      emailRules: [
        v => !!v || 'Kötelező kitölteni!',
        v => /.+@.+\..+/.test(v) || 'Nem megfelelő e-mail cím formátum!',
      ],
      simpleRules: [
        v => !!v || 'Kötelező kitölteni!'
      ],
      passwordRules: [
        v => !!v || 'Kötelező kitölteni!',
        v => (v && v.length >= 6) || 'A jelszónak legalább 6 karakter hosszúnak kell lennie!',
      ],
      repPasswordRules: [
        v => !!v || 'Kötelező kitölteni!',
        v => (v == this.reg_password) || 'A beírt jelszó nem egyezik!',
      ],
      repNewPasswordRules: [
        v => !!v || 'Kötelező kitölteni!',
        v => (v == this.new_password) || 'A beírt jelszó nem egyezik!',
      ],
      reg_success_dialog: false,
      reg_button_loading: false,
      reg_error_text: '',
      reg_error_dialog: false,
      CaptchaVerified: false,
      customer_ids: [],
      vartification_dialog: false,
      vertification: '',
      vartification_error: '',
      vartification_snackbar: false,
      contract_choose_dialog: false,
      contracts: [],
      selected_contract: '',
      selected_customer_id: '',
      selected_name: '',
      selected_reg_date: '',
      selected_contract_name: '',
      selected_contract_date: '',
      login_progress: false,
      contract_confirm_dialog: false,
      pass_reset_dialog: false,
      passwordResetEmail: '',
      password_reset_error: '',
      new_password: '',
      new_repeat_password: '',
      response_success: '',
      login_token: '',
      login_user_check: '',
      adatkezeles: '',
      reg_error_code: '',
      reg_vartification_dialog: false,
      reg_vertification_code: '',
      registration_loading: false,
      tokenteszt: '',
      sitekey: "6LcwTrEZAAAAADMg6EdCnIipA0AFb3ST_KAsPs3G",
      old_reg_button_load: false,
      contracts_header: [
        { text: 'Név', value: 'full_name'},
        { text: 'Regisztráció ideje', value: 'registration_date' },
        { text: 'Szerződés kategóriája', value: 'contract_name' },
        { text: 'Szerződéskötés ideje', value: 'contract_date' },
      ],
    }
  },
  methods: {
    anomLogin: function() {
      firebase.auth().signInAnonymously().then(function() {
      }).catch(function(error) {
        console.log(error);
      });
    },
    Login: function (recaptcha_token) {
      //this.loginRecaptchaReset()
      this.login_user_check = null
      this.reg_error_code = null
      this.login_progress = true
      var self = this
      self.$http.post('/login/recaptcha', {
        token: recaptcha_token
      }).then((response) => {
        this.loginRecaptchaReset()
        if (response.data['success'] == 'token_error') {
          self.reg_error_dialog = true
          self.reg_error_text = response.data['message'];
          self.login_progress = false
        } else {
          firebase.auth().signInWithEmailAndPassword(this.username, this.password).then(function() {
            self.$router.push({name: 'home'});
            self.login_progress = false
          }).catch(function(error) {
            console.log(error);
            if (error.code == 'auth/user-not-found') {
            self.$http.post('/login/login_user_check', {
              username: self.username
            }).then((response) => {
              self.login_progress = false
              if (response.data['success'] == 'false') {
                self.reg_error_dialog = true
                self.reg_error_text = 'A megadott e-mail címmel nincs regisztrált felhasználó!'
              } else if (response.data['success'] == 'true') {
                self.login_user_check = response.data['success']
                self.reg_error_dialog = true
                self.reg_error_text = response.data['message'];
              }
            }, (error) => {
              console.log(error.data);
            })
           } else if (error.code == 'auth/wrong-password') {
             self.reg_error_code = 'auth/wrong-password'
             self.login_progress = false
             self.reg_error_dialog = true
             self.reg_error_text = 'A megadott jelszó nem megfelelő!'
           } else if (error.code == 'auth/too-many-requests') {
             self.login_progress = false
             self.reg_error_dialog = true
             self.reg_error_text = 'Túl sok sikertelen próbálkozás miatt átmenetileg letiltottuk a bejelentkezési lehetőséget! Kérjük próbálja meg később, vagy kérjen jelszó emlékeztetőt!'
           } else if (error.code == 'auth/invalid-email') {
             self.login_progress = false
             self.reg_error_dialog = true
             self.reg_error_text = 'A megadott e-mail cím nem megfelelő formátumú (lehet, hogy üres karakter, szóköz van az elején vagy végén)!'
           } else {
             self.login_progress = false
             self.reg_error_dialog = true
             self.reg_error_text = error.message
           }
         });
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    LoginVerfify: function () {
      this.$http.post('/login/get_accounts', {
        jwt: this.token,
        token: this.vertification,
        username: this.reg_username
      }).then((response) => {
        if (response.data['success'] == 'false') {
          this.response_success = response.data['success']
          this.vartification_error = response.data['message']
          this.vartification_snackbar = true
        } else if (response.data['success'] == 'true') {
          this.response_success = response.data['success']
          this.vartification_dialog = false
          this.contracts = response.data['customers']
          this.contract_choose_dialog = true
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    emailVertify: async function() {
      await this.gettoken()
      this.$http.post('/login/email_vertify_token', {
        username: this.reg_username,
        token: this.token,
      }).then((response) => {
        this.reg_button_loading = false
        if (response.data['success'] == 'token_error') {
          this.reg_error_dialog = true
          this.reg_error_text = response.data['message'];
        } else {
          this.reg_vartification_dialog = true
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    loginRecaptchaReset: function () {
      this.$refs.login_recaptcha.reset();
    },
    loginRecaptchaExecute: function () {
      this.$refs.login_recaptcha.execute();
    },
    regRecaptchaReset: function () {
      this.$refs.reg_recaptcha.reset();
    },
    regRecaptchaExecute: function () {
      this.$refs.reg_recaptcha.execute();
    },
    pwRecaptchaReset: function () {
      this.$refs.pwreset_recaptcha.reset();
    },
    pwRecaptchaExecute: function () {
      this.$refs.pwreset_recaptcha.execute();
    },
    Registration: function (recaptcha_token) {
      this.regRecaptchaReset()
      this.login_user_check = null
      this.reg_button_loading = true
      var self = this
      self.$http.post('/login/recaptcha', {
        token: recaptcha_token
      }).then((response) => {
        if (response.data['success'] == 'token_error') {
          self.reg_error_dialog = true
          self.reg_error_text = response.data['message'];
          self.login_progress = false
        } else {
          firebase.auth().fetchSignInMethodsForEmail(self.reg_username).then(function(response) {
            if (response != "") {
              self.reg_error_dialog = true
              self.reg_error_text = 'A megadott e-mail cím már foglalt! Kérjük jelentkezzen be vagy kérjen jelszó emlékeztetőt!';
              self.reg_dialog = false
            } else {
              // Anonymous login
              firebase.auth().signInAnonymously().then(function() {
                self.oldUserCheck()
              }).catch(function(error) {
                console.log(error);
              });
            }
          }).catch(function(error) {
            console.log(error);
          });
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    oldUserCheck: async function() {
      await this.gettoken()
      this.$http.post('/login/all_user_check', {
        username: this.reg_username,
        token: this.token, // Anonymous token
      }).then((response) => {
        if (response.data['success'] == 'false') {
            this.emailVertify()
        } else if (response.data['success'] == 'true') {
          this.reg_button_loading = false
          this.username = this.reg_username
          this.password = this.reg_password
          this.vartification_dialog = true
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    newRegistration: async function() {
      await this.gettoken()
      this.registration_loading = true
      this.$http.post('/login/email_vertification', {
        jwt: this.token,
        token: this.reg_vertification_code,
        username: this.reg_username
      }).then((response) => {
        if (response.data['success'] == 'false') {
          this.registration_loading = false
          this.response_success = response.data['success']
          this.vartification_error = response.data['message']
          this.vartification_snackbar = true
        } else if (response.data['success'] == 'true') {
          var self = this
          var credential = firebase.auth.EmailAuthProvider.credential(self.reg_username, self.reg_password);
          firebase.auth().currentUser.linkWithCredential(credential).then(function() {
           firebase.auth().currentUser.getIdToken().then((idToken) => {
            self.$http.post('/login/new_user_reg', {
              token: idToken,
              email: self.reg_username
            }).then((response) => {
              self.registration_loading = false
              self.vartification_error = response.data['message']
              self.response_success = response.data['success']
              self.vartification_snackbar = true
              self.userState()
              self.$router.push({name: 'home'});
            }, (error) => {
              console.log(error.data);
            })
            }).catch((error) => {
              alert(error)
            })
          }).catch(function(error) {
            console.log(error);
            self.reg_error_dialog = true
            if (error.code == 'auth/email-already-in-use') {
              self.reg_error_text = 'A megadott e-mail cím már foglalt!';
            } else {
              self.reg_error_text = error.message;
            }
          });
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    oldRegistration: function () {
      this.old_reg_button_load = true
      var self = this
      var credential = firebase.auth.EmailAuthProvider.credential(self.reg_username, self.reg_password);
      firebase.auth().currentUser.linkWithCredential(credential).then(function() {
        firebase.auth().currentUser.getIdToken().then((idToken) => {
          self.$http.post('/login/old_user_reg', {
            token: idToken,
            customer_id: self.selected_customer_id,
            email: self.reg_username,
          }).then((response) => {
            console.log(response);
            self.old_reg_button_load = false
            //var href = location.origin;
            //location.assign(href+"/adatok");
            self.userState()
            self.$router.push({name: 'home'});
          }, (error) => {
            console.log(error.data);
          })
        }).catch((error) => {
          alert(error)
        })
      }).catch(function(error) {
        alert(error)
      });
    },
    userState: async function () {
      await this.gettoken()
      var user = firebase.auth().currentUser;
      if (user) {
        this.fbuser = user.email
        this.$http.post('/login/check_customer', {
          token: this.token,
        }).then((response) => {
          this.customer_name = response.data[0]['full_name']
          this.customer_id = response.data[0]['customer_id']
        }, (error) => {
          console.log(error.data);
        })
      } else {
        console.log("No user is signed in.");
      }
    },
    logout: function () {
      var self = this
      firebase.auth().signOut().then(function() {
        self.customer_id = null
        self.customer_name = null
        self.fbuser = null
      }).catch(function(error) {
        alert(error)
      });
    },
    passwordReset: function (recaptcha_token) {
      this.pwRecaptchaReset()
      this.password_reset_error = null
      var self = this
      var auth = firebase.auth();
      self.$http.post('/login/recaptcha', {
        token: recaptcha_token
      }).then((response) => {
        if (response.data['success'] == 'token_error') {
          self.reg_error_dialog = true
          self.reg_error_text = response.data['message'];
        } else {
          auth.sendPasswordResetEmail(self.passwordResetEmail).then(function() {
            self.vartification_snackbar = true
            self.vartification_error = 'A jelszó visszaállításhoz szükséges e-mailt elküldtük!'
            self.pass_reset_dialog = false
          }).catch(function(error) {
            if (error.code == 'auth/user-not-found') {
              self.password_reset_error = 'A megadott e-mail címmel nem található regisztrált felhasználó!'
            } else if (error.code == 'auth/invalid-email') {
              self.password_reset_error = 'A megadott e-mail cím nem megfelelő formátumú!'
            } else {
              self.password_reset_error = error.message
            }
          });
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    passwordChange: function () {
      var user = firebase.auth().currentUser;
      var newPassword = this.new_password;
      var self = this
      user.updatePassword(newPassword).then(function() {
        self.vartification_snackbar = true
        self.vartification_error = 'A jelszó módosítás sikeres!'
      }).catch(function(error) {
        console.log(error);
        self.vartification_snackbar = true
        self.vartification_error = 'A jelszó módosítás sikertelen!'
      });
    }
  },
  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.userState();
      }
    })
  },
  computed: {
  ...mapFields([
    'ids.customer_id',
    'ids.customer_name',
    'actions.preloader',
  ]),
},
}
</script>

<style >

</style>
